
import React from 'react'
import { useNavigate } from 'react-router-dom'
import AiEmpty from "@/components/AiEmpty";
import Icon from '../../../components/Icon'
import car_icon from '@/images/car_icon.png'
import AiPermission from '../../../components/AiPermission'
import icon_biezhen from '@/images/icon_biezhen.png'
import { Toast } from 'antd-mobile'
import { SwipeActionProps } from 'antd-mobile/es/components/swipe-action'
import copyToClipboard from '../../../utils/copyToClipboard'
import telPhoneByNumber from '../../../utils/telPhoneByNumber'
import day from 'dayjs'
import './index.scss'

export interface VehicleListProps {
    dataList: any
    isDelete?:boolean
    SwipeActionProps?:SwipeActionProps
    isEmpty?:boolean
    loading?:boolean
    onDelete?: (index:number,item:any) => void // 左上角自定义返回函数
    onNavigate?: (value, index) => void // 自定义跳转
    handleNavigate?: (item:any, index:any) => void 
    isClick?:boolean
    binding?:boolean //是否需要显示绑定客户
    handleBind?: (item:any) => void 
}
// 格式化到店天数
const formatDayName = (value) => {
    if(value === -1) {
        return '(未到店)'
    }else if(value === 0){
        return '(今日到店)'
    }else if(value === 1){
        return '(昨日到店)'
    }else if(  value *1 < 6  && value *1 > 2 ){
        return '(7天内到店)'
    }else {
        return `(${value}天前到店)`
    }
}
const VehicleList: React.FC<VehicleListProps> = ({isClick = true, binding = false, loading = true, isEmpty = true, isDelete = false, SwipeActionProps = {}, dataList = [], ...props }) => {
    let navigate = useNavigate()
    const handleDelete = (index,item) => {
        if(props?.onDelete) {
            props.onDelete(index,item)
        }
    }
    const handleNavigate = (item, index) => {
        if( !isClick ) {
            return
        }
        if(props.onNavigate) {
            props.onNavigate(item, index)
            return
        }
        if( props?.handleNavigate ) {
            props?.handleNavigate(item, index);
            return
        }
        navigate(`/addCar?carNo=${item.carNo}&type=2`)
    }
    const handleBind = (item) => {
        props?.handleBind && props?.handleBind(item)
    }
    
    const handleCopy = (text) => {
        if( !text ) {
            return
        }
        copyToClipboard(text);
        Toast.show('车牌复制成功!')
    }
    const _telPhoneByNumber = (text) => {
        if( !text ) {
            return
        }
        telPhoneByNumber(text)
    }
    
    return (
        <div className='vehicle-user-wrapper-list-item-content'>
            {/* 需要显示暂无数据 且不在加载数据 且数组为空 */}
            {isEmpty && !loading && !dataList.length && <AiEmpty />}
            {dataList && !!dataList?.length && <>
                {dataList.map((item, index) => (
                    
                    <AiPermission permission={['car:car:info']} key={index}>
                        <div className='vehicle-user-wrapper-list-item-content-item' onClick={() => handleNavigate(item, index)}>
                            <div className='content-item-vehicle'>
                                <div className='content-item-image'>
                                    {isDelete && <span className='content-item-portrait-delete' onClick={() => handleDelete(index,item)}><Icon icon="&#xe71a;" /></span>}
                                    <img className='content-item-portrait-img' src={item.icon ? item.icon : car_icon} alt="" />
                                    {!!item.vipTypeIcon && <img className='content-item-portrait-vip' src={item.vipTypeIcon} alt="" />}
                                    <p style={{transform: 'translateY(-50%)', fontSize: '.2133rem',color: '#FFFFFF',height: '.2667rem',background: '#10C294','padding':'0 .16rem','borderRadius': '.16rem','whiteSpace': 'nowrap'}}>{item.carAge || 0}年</p>
                                </div>
                                <div className='content-itme-body'>
                                    <div className='content-itme-body-car'>
                                        <div>
                                            <b onClick={(event) => {
                                                event.stopPropagation();
                                                handleCopy(item.carNo)
                                            }}>{item.carNo}</b>
                                            {!item.userPk && <p onClick={() => handleBind(item)}><img src={icon_biezhen} alt=""/> <i>绑定客户</i> </p>}
                                            {item.userPk && <><span>{item.userName}</span>
                                            <span onClick={(event) => {
                                                event.stopPropagation();
                                                _telPhoneByNumber(item.userPhone)
                                            }}>{item.userPhone}</span></>}
                                        </div>
                                        <div>{item.cuurentMileage || 0}km</div>
                                    </div>
                                    <div className='content-itme-body-car-type'>
                                        <p>{item.type || '暂无车型信息'}</p>
                                    </div>
                                    {/* <div className='content-itme-body-car-state'>
                                        <div className='content-itme-body-car-state-project'>
                                            {item.lostStatus === '1' && <p>{['未流失','已流失'][item.lostStatus]}</p>}
                                            {!!item.consumeType && (item.consumeType.split(',').filter((i,o) => o < 3)).map((itemName, index) => (
                                                <span key={index}>{itemName}</span>
                                            ))}
                                            {!!item?.consumeType && item.consumeType.split(',')?.length > 3 && <h1>...{item.consumeType.split(',')?.length}</h1>}
                                        </div>
                                        {!!item?.consumeAmount && <div className='content-itme-body-car-state-consumption'>总消费: {item.consumeAmount || 0}元</div>}
                                    </div> */}
                                </div>
                            </div>

                            <div className='license-plate-wrapper-car-price'>
                                <p>{item.carInfoFinishRate || 0}%</p>
                                <div>
                                    <p>新车指导价: {item?.carPrice ? `${item?.carPrice}万元` : '--'}</p>
                                    <div className='license-plate-wrapper-consumption'>
                                        <div><Icon icon='&#xe766;' style={{'color':'#B68D41'}} />共<b className='consumption-color' style={{'color':'#B68D41'}}>{item.consumeCardCount || 0}</b>张</div>
                                        <div><Icon icon='&#xe762;' style={{'color':'#FE8727'}} />共<b className='consumption-color' style={{'color':'#FE8727'}}>{item.cardCount || 0}</b>张</div>
                                    </div>
                                </div>
                            </div>



                            <div className='foot'>

                                
                                <div className='foot-item'>
                                    <div className='foot-item-left'>
                                        <em>上次进店:</em><i>{item?.cuurentMaintainTime ? day(item?.cuurentMaintainTime).format('YYYY-MM-DD') : '--'}</i>
                                        {!!item?.cuurentMaintainTime && <>
                                            {item.noInstoreDay > 0 && <>
                                                <i>(</i> 
                                                <b>{item.noInstoreDay}</b>
                                                <span>天未到店)</span>
                                            </>}
                                            {item.noInstoreDay === 0 && <>
                                                <i>(今天</i> 
                                                <span>到店)</span>
                                            </>}
                                        </>}
                                    </div>
                                    <div className='foot-item-right' style={{'display':'flex','justifyContent':'space-between'}}>
                                        <div><em>共到店:</em><b>{item?.inStoreCount || 0}</b><span>次</span></div>
                                        <div><em>预检:</em><b>{item?.preCheckCount || 0}</b><span>次</span></div>
                                        <div><em>检测:</em><b>{item?.checkCount || 0}</b><span>次</span></div>
                                    </div>
                                </div>
                                <div className='foot-item'>
                                    <div className='foot-item-left'>
                                        <em>保养到期:</em>
                                        {!item?.engineOilNextMaintenanceTime && <i>--</i>}
                                        {!!item?.engineOilNextMaintenanceTime && <>
                                            {item.nextMaintiandays >= 0 && <>
                                                <i>{day(item?.engineOilNextMaintenanceTime).format('YYYY-MM-DD')}
                                                (还有</i>
                                                <b>{item.nextMaintiandays}</b><span>天)</span>
                                            </>}
                                            {item.nextMaintiandays < 0 && <>
                                                <i>{day(item?.engineOilNextMaintenanceTime).format('YYYY-MM-DD')}
                                                (已到期</i>
                                                <b>{Math.abs(item.nextMaintiandays)}</b><span>天)</span>
                                            </>}
                                        </>}
                                    </div>
                                    <div className='foot-item-right' style={{'display':'flex','justifyContent':'space-between','paddingRight': '.8rem'}}>
                                        <div><em>提醒:</em><b>{item?.remindCount || 0}</b><span>条</span></div>
                                        <div><em>未处理异常:</em><b>{item?.remindCount || 0}</b><span>项</span></div>
                                    </div>
                                </div>
                                <div className='foot-item'>
                                    <div className='foot-item-left'>
                                        <em>年审到期:</em>
                                        {!item?.lastYearCheckTime && <i>--</i>}
                                        {!!item?.lastYearCheckTime && <>
                                            {item.yearCheckExpireDays >= 0 &&<>
                                                <i>{item?.lastYearCheckTime}(还有</i>
                                                <b>{item.yearCheckExpireDays}</b>
                                                <span>天)</span>
                                            </>}
                                            {item.yearCheckExpireDays < 0 && <>
                                                <i>{item?.lastYearCheckTime}(已到期</i>
                                                <b>{Math.abs(item.yearCheckExpireDays)}</b>
                                                <span>天)</span>
                                            </>}
                                        </>}
                                    </div>
                                    <div className='foot-item-right'>
                                        <em>累计消费:</em><b>{item?.consumeAmount || 0}元</b>
                                    </div>
                                </div>


                                <div className='foot-item'>
                                    <div className='foot-item-left'>
                                        <em>交强险购买:</em>
                                        {!item?.buyTime && <i>--</i>}
                                        {!!item?.buyTime && <>
                                            {item.insuranceExpireDays >= 0 && <>
                                                <i>{item?.buyTime}(还有</i>
                                                <b>{item.insuranceExpireDays}</b>
                                                <span>天)</span>
                                            </>}
                                            {item.insuranceExpireDays < 0 && <>
                                                <i>{item?.buyTime}(已到期</i>
                                                <b>{Math.abs(item.insuranceExpireDays)}</b>
                                                <span>天)</span>
                                            </>}
                                        </>}
                                    </div>
                                    <div className='foot-item-right'>
                                        <em>商业险购买:</em>
                                        {!item?.businessInsuranceTime && <i>--</i>}
                                        {!!item?.businessInsuranceTime && <>
                                            {item.businessInsuranceExpireDays >= 0 && <>
                                                <i>{item?.businessInsuranceTime}(还有</i>
                                                <b>{item.businessInsuranceExpireDays}</b>
                                                <span>天)</span>
                                            </>}
                                            {item.businessInsuranceExpireDays < 0 && <>
                                                <i>{item?.businessInsuranceTime}(已到期</i>
                                                <b>{Math.abs(item.businessInsuranceExpireDays)}</b>
                                                <span>天)</span>
                                            </>}
                                        </>}
                                    </div>
                                </div>


                                {/* <div className='content-item-vehicle-date'>
                                    <div>
                                        <span>共到店<b>{item.inStoreCount || 0}</b>次{(item.cuurentMaintainTime && !!item?.inStoreCount) ? '｜' : ''}</span>
                                        {item.cuurentMaintainTime && !!item?.inStoreCount && <>上次进店{item.cuurentMaintainTime}(<b>{item.noInstoreDay}</b>天未到店) </>}
                                    </div>
                                    <div>
                                        预检: <b>{item?.preCheckCount || 0}</b>次
                                        检测: <b>{item?.checkCount || 0}</b>次
                                    </div>
                                </div>
                                <div className='content-item-vehicle-date'>
                                    <div>
                                        <div>预计下次保养时间:{item?.nextMaintianDate || '无'}{!!item?.nextMaintianDate &&<>(还有{item.nextMaintiandays}天)</>}</div>
                                    </div>
                                    <div>
                                        未处理异常: <b>{item.exceptionCount || 0}</b>项
                                        提醒: <b>{item.remindCount}</b>条
                                    </div>
                                </div> */}

                                
                            </div>
                        </div>
                    </AiPermission>
                ))}
            </>}
        </div>
    )
}

export default VehicleList